import React from 'react';
import { View, Text, StyleSheet, ScrollView, Platform, useWindowDimensions } from 'react-native';
import { colores, fuentes } from '../../styles/variablesCss';

const Manifiesto = () => {
  const { width } = useWindowDimensions();
  const isSmall = width < 768;

  return (
    <ScrollView contentContainerStyle={styles.page}>

      <View style={styles.heroBlock}>
        <View style={{ width: '100%', textAlign: 'center', marginBottom: 16 }}>
          <img
            alt="Manifiesto Pingüino"
            src="https://www.pinguino.com.ar/static/img/manifiesto/manifiesto.png"
            style={{ width: '100%', maxWidth: 700, marginTop: 35, display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
          />  
        </View>
        <View style={{ width: isSmall ? '40%' : '20%', alignSelf: 'center', marginBottom: 16 }}>
          <img
            alt="Manifiesto Pingüino"
            src="https://www.pinguino.com.ar/static/img/manifiesto/Pinguino-rojo.png"
            style={{ maxWidth: 230, height: 'auto', display: 'block', objectFit: 'cover' }}
          />
        </View>
        <View style={[styles.hero, { flexDirection: isSmall ? 'column' : 'row', alignItems: 'stretch', justifyContent: 'center' }]}>
          <View style={[styles.heroLeft, { flex: isSmall ? undefined : 1, paddingVertical: isSmall ? 20 : 30 }]}>
            <Text style={[styles.heroHeading, {fontSize: isSmall ? 28 : 36, lineHeight: isSmall ? 34 : 42 }]}>Qué</Text>
            <Text style={[styles.heroHeading, {fontSize: isSmall ? 28 : 36, lineHeight: isSmall ? 34 : 42 }]}>nos mueve,</Text>
            <Text style={[styles.heroHeading, {fontSize: isSmall ? 28 : 36, lineHeight: isSmall ? 34 : 42 }]}>y hacia</Text>
            <Text style={[styles.heroHeading, {fontSize: isSmall ? 28 : 36, lineHeight: isSmall ? 34 : 42 }]}>dónde.</Text>
          </View>

          <View style={[styles.heroRight, { flex: isSmall ? undefined : 2, paddingVertical: isSmall ? 20 : 30 }]}>
            <Text style={[styles.heroParagraph, { fontSize: 20, lineHeight: 28 }]}>Nuestro Manifiesto es el elemento de visualización de nuestro propósito.</Text>
            <Text style={[styles.heroParagraph, { fontSize: 20, lineHeight: 28 }]}>Inspira a nuestros colaboradores, a nuestros clientes, a nuestra comunidad y sus organizaciones.</Text>
            <Text style={[styles.heroParagraph, { fontSize: 20, lineHeight: 28 }]}>Ayuda a atraer talento.</Text>
            <Text style={[styles.heroParagraph, { fontSize: 20, lineHeight: 28 }]}>Fue construido a partir del principio de autenticidad, un valor que nos identifica como marca y como empresa.</Text>
            <Text style={[styles.heroParagraph, { fontSize: 20, lineHeight: 28 }]}>Nuestro manifiesto está cargado de energía, es nuestra forma Pingüino de hacer las cosas.</Text>
            <Text style={[styles.heroParagraph, { fontSize: 20, lineHeight: 28 }]}>Y eso, nos hace ÚNICOS.</Text>
          </View>
        </View>
      </View>
      {/* Bloque 50/50: Imagen izquierda, texto derecha */}
      <View style={[styles.splitBlock, { flexDirection: isSmall ? 'column' : 'row' }]}>
        <View style={[styles.splitLeft, { width: isSmall ? '100%' : '50%'}]}>
          <View style={styles.imageBox}>
            <img
              alt="Manifiesto Pingüino"
              src="https://www.pinguino.com.ar/static/img/manifiesto/imagen1.png"
              style={{ objectFit: 'cover', display: 'block' }}
            />
          </View>
        </View>
        <View style={[styles.splitRight, { width: isSmall ? '100%' : '50%', paddingLeft: 70, }]}> 
          <Text style={[styles.TituloManifiesto,]}>Nuestro Manifiesto</Text>
          <Text style={[styles.TituloManifiesto,]}>está compuesto por</Text>
          <Text style={[styles.TituloManifiesto,]}>10 principios.</Text>
          <Text style={[styles.splitSubtitle, {marginVertical: 32}]}>¡Es eso que nos identifica!</Text>

          <View style={styles.listBlock}>
            <Text style={styles.listItem}>01 - Valoramos lo simple</Text>
            <Text style={styles.listItem}>02 - Bancamos la autenticidad</Text>
            <Text style={styles.listItem}>03 - Estamos del lado del diálogo</Text>
            <Text style={styles.listItem}>04 - Sabemos que la confianza es la base de todo</Text>
            <Text style={styles.listItem}>05 - La sustentabilidad es un modo de ser y hacer</Text>
            <Text style={styles.listItem}>06 - Damos todo. Y recibimos todo también</Text>
            <Text style={styles.listItem}>07 - Comercio responsable: Nuestra forma de hacer las cosas</Text>
            <Text style={styles.listItem}>08 - La alegría es nuestro motor</Text>
            <Text style={styles.listItem}>09 - Si crece uno, crecemos todos</Text>
            <Text style={styles.listItem}>10 - Ser nuestra mejor versión</Text>
          </View>
        </View>
      </View>

      {/* Bloque 50/50 invertido: Texto izquierda, imagen derecha (01) */}
      <View style={[styles.splitBlock, { flexDirection: isSmall ? 'column' : 'row' }]}>
        <View style={[styles.splitRight, { width: isSmall ? '100%' : '50%', paddingLeft: 20, paddingRight: 70, }]}>
          <Text style={[styles.TituloManifiesto, { color: '#3e8fcd', marginBottom: 28 }]}>01</Text>
          <Text style={[styles.TituloManifiesto, { color: '#3e8fcd', }]}>Valoramos{"\n"}lo simple.</Text>
          <Text style={[styles.listItemBold, { marginTop: 32 }]}>¿Qué nos mueve?</Text>
          <Text style={[styles.listItem, { marginBottom: 12 }]}>SIMPLIFICAR LA VIDA DE LAS PERSONAS.</Text>

          <Text style={styles.listItemBold}>Volver a lo simple.</Text>
          <Text style={styles.listItem}>
            Para el cliente en su proceso de compra y también para todos los que formamos parte del equipo Pingüino. En nuestro trabajo, en casa, con nuestros amigos, en el día a día.
          </Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Simple es:</Text>
          <Text style={styles.listItem}>
            Lo que no tiene procesos complejos, lo que es fácil de entender, lo que es intuitivo. Simplificar la complejidad de una organización, para lograr que en las personas quede lo más importante: relacionarnos, intercambiar información, construir buenas costumbres.
          </Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Palabras clave</Text>
          <Text style={styles.listItem}>
            Dar lo mejor para simplificar la vida de las personas. Lo simple da placer. Las buenas acciones abren puertas.
          </Text>
          <Text style={[styles.listItem]}>TECNOLOGÍA / ACCIÓN / VALORES</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>¿Cómo lo hacemos?</Text>
          <Text style={styles.listItem}>
            Transmitimos, valoramos, destacamos, premiamos los valores y las buenas acciones.
          </Text>
        </View>

        <View style={[styles.splitLeft, { width: isSmall ? '100%' : '50%',}]}>
          <View style={styles.imageBox}>
            <img
              alt="Valoramos lo simple"
              src="https://www.pinguino.com.ar/static/img/manifiesto/01.jpg"
              style={{ objectFit: 'cover', display: 'block' }}
            />
          </View>
        </View>
      </View>

      {/* Bloque 50/50: Imagen izquierda, texto derecha (02) */}
      <View style={[styles.splitBlock, { flexDirection: isSmall ? 'column' : 'row' }]}>
        <View style={[styles.splitLeft, { width: isSmall ? '100%' : '50%', }]}>
          <View style={styles.imageBox}>
            <img
              alt="Bancamos la autenticidad"
              src="https://www.pinguino.com.ar/static/img/manifiesto/02.jpg"
              style={{objectFit: 'cover', display: 'block' }}
            />
          </View>
        </View>
        <View style={[styles.splitRight, { width: isSmall ? '100%' : '50%', paddingLeft: 70, paddingRight: 10, }]}>
          <Text style={[styles.TituloManifiesto, { color: '#f59aa6', marginBottom: 28 }]}>02</Text>
          <Text style={[styles.TituloManifiesto, { color: '#f59aa6' }]}>Bancamos{"\n"}la autenticidad.</Text>
          <Text style={[styles.listItemBold, { marginTop: 32 }]}>¿Qué nos mueve?</Text>
          <Text style={[styles.listItem, { marginBottom: 12 }]}>LA DIVERSIDAD Y LA EXPRESIÓN DE TODAS LAS VOCES.</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Ser auténticos es:</Text>
          <Text style={styles.listItem}>
            Saber que todos tenemos algo para dar, algo que enseñar, algo que transmitir.
          </Text>
          <Text style={styles.listItem}>
            Ver a las personas y a cada intercambio como una oportunidad, eso cambia nuestra percepción sobre cómo nos relacionamos y valoramos.
          </Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Palabras Clave</Text>
          <Text style={styles.listItem}>
            Cuando nos escuchamos, crecemos. Sumar voces, sumar valor.
          </Text>
          <Text style={[styles.listItem, { marginBottom: 12 }]}>De lo que sos vos, yo también aprendo.</Text>
          <Text style={styles.listItem}>TRANSPARENCIA / OPORTUNIDAD / DIVERSIDAD</Text>

          <Text style={[styles.listItemBold, { marginTop: 10 }]}>¿Cómo lo hacemos?</Text>
          <Text style={styles.listItem}>Trabajamos en equipo. Escuchamos.</Text>
        </View>
      </View>
      <View style={[styles.splitBlock, { flexDirection: isSmall ? 'column' : 'row' }]}>
        <View style={[styles.splitRight, { width: isSmall ? '100%' : '50%', paddingLeft: 20, paddingRight: 70, }]}>
          <Text style={[styles.TituloManifiesto, { color: '#f37213', marginBottom: 28 }]}>03</Text>
          <Text style={[styles.TituloManifiesto, { color: '#f37213' }]}>Estamos del lado{"\n"}del diálogo.</Text>
          <Text style={[styles.listItemBold, { marginTop: 32 }]}>¿Qué nos mueve?</Text>
          <Text style={[styles.listItem, { marginBottom: 12 }]}>LA COMUNICACIÓN HONESTA Y RESPONSABLE.</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Comunicación honesta y responsable es:</Text>
          <Text style={styles.listItem}>Escuchar. Dialogar. Empatizar. Consensuar.</Text>
          <Text style={styles.listItem}>Construir nuestro mensaje a partir de eso.</Text>
          <Text style={styles.listItem}>Poder unirnos, para que todas las partes logren sus objetivos, proponer acuerdos.</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Palabras clave</Text>
          <Text style={styles.listItem}>Qué bueno entendernos.</Text>
          <Text style={styles.listItem}>Nuestras ideas nos dan libertad.</Text>
          <Text style={styles.listItem}>Conectados por las ideas.</Text>
          <Text style={[styles.listItem, { marginTop: 18 }]}>CENTRO EN LAS PERSONAS / CONSENSO / DIÁLOGO</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>¿Cómo lo hacemos?</Text>
          <Text style={styles.listItem}>Respetamos las distintas miradas.</Text>
        </View>
        <View style={[styles.splitLeft, { width: isSmall ? '100%' : '50%', }]}>
          <View style={styles.imageBox}>
            <img
              alt="Estamos del lado del diálogo"
              src="https://www.pinguino.com.ar/static/img/manifiesto/03.jpg"
              style={{objectFit: 'cover', display: 'block' }}
            />
          </View>
        </View>
      </View>

      <View style={[styles.splitBlock, { flexDirection: isSmall ? 'column' : 'row' }]}>
        <View style={[styles.splitLeft, { width: isSmall ? '100%' : '50%', }]}>
          <View style={styles.imageBox}>
            <img
              alt="Sabemos que la confianza es la base de todo"
              src="https://www.pinguino.com.ar/static/img/manifiesto/04.jpg"
              style={{objectFit: 'cover', display: 'block' }}
            />
          </View>
        </View>
        <View style={[styles.splitRight, { width: isSmall ? '100%' : '50%', paddingLeft: 70, paddingRight: 10, }]}>
          <Text style={[styles.TituloManifiesto, { marginBottom: 28, color: '#f59aa6' }]}>04</Text>
          <Text style={[styles.TituloManifiesto, {color: '#f59aa6'}]}>Sabemos que{"\n"}la confianza es{"\n"}la base de todo.</Text>
          <Text style={[styles.listItemBold, { marginTop: 32 }]}>¿Qué nos mueve?</Text>
          <Text style={[styles.listItem, { marginBottom: 12 }]}>GENERAR RELACIONES DE CONFIANZA Y A LARGO PLAZO.</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Confianza es:</Text>
          <Text style={styles.listItem}>Creer en nuestros equipos. Eso aporta seguridad, tranquilidad, y hace que ellos también confíen en nosotros.</Text>
          <Text style={styles.listItem}>Conectar con personas que se toman las cosas con responsabilidad, conciencia y profesionalismo.</Text>
          <Text style={styles.listItem}>Brindar cosas buenas, para atraer cosas buenas. Avanzar sabiendo que cada uno hace bien lo suyo.</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Palabras Clave</Text>
          <Text style={styles.listItem}>Solo podemos trabajar en equipo si confiamos en el otro.</Text>
          <Text style={styles.listItem}>Cada uno hace bien su parte, y así ganamos todos.</Text>
          <Text style={[styles.listItem, { marginTop: 18 }]}>COLABORACIÓN / RESPONSABILIDAD / CONFIANZA</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>¿Cómo lo hacemos?</Text>
          <Text style={styles.listItem}>La confianza generada en un grupo o sociedad nos da tranquilidad.</Text>
        </View>
      </View>

      <View style={[styles.splitBlock, { flexDirection: isSmall ? 'column' : 'row' }]}>
        <View style={[styles.splitRight, { width: isSmall ? '100%' : '50%', paddingLeft: 20, paddingRight: 70, }]}>
          <Text style={[styles.TituloManifiesto, { color: '#23abe2', marginBottom: 28 }]}>05</Text>
          <Text style={[styles.TituloManifiesto, {color: '#23abe2'}]}>La sustentabilidad{"\n"}es un modo de ser{"\n"}y hacer.</Text>
          <Text style={[styles.listItemBold, { marginTop: 32 }]}>¿Qué nos mueve?</Text>
          <Text style={[styles.listItem, { marginBottom: 12 }]}>NUESTRO COMPROMISO CON EL ENTORNO SOCIAL Y AMBIENTAL.</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Sustentabilidad es:</Text>
          <Text style={styles.listItem}>Pensar formas más simples y sostenibles de hacer.</Text>
          <Text style={styles.listItem}>Ser conscientes de la huella que dejamos, buscar tener el menor impacto posible y también generar un efecto positivo.</Text>
          <Text style={styles.listItem}>Estar comprometidos con una mayor concientización de nuestra comunidad.</Text>
          <Text style={styles.listItem}>Las relaciones a largo plazo.</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Palabras clave</Text>
          <Text style={styles.listItem}>Somos naturaleza y vivimos en ella, cuidarla es cuidarnos.</Text>
          <Text style={styles.listItem}>Amor por lo que somos y hacemos.</Text>
          <Text style={styles.listItem}>Estamos del lado de generar siempre un impacto positivo.</Text>
          <Text style={[styles.listItem, { marginTop: 18 }]}>COMPROMISO / CUIDADO DEL AMBIENTE / SUSTENTABILIDAD</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>¿Cómo lo hacemos?</Text>
          <Text style={styles.listItem}>Pensamos en el impacto que generamos en todos nuestros públicos y tratamos de minimizarlo.</Text>
        </View>
        <View style={[styles.splitLeft, { width: isSmall ? '100%' : '50%', }]}>
          <View style={styles.imageBox}>
            <img
              alt="La sustentabilidad es un modo de ser y hacer"
              src="https://www.pinguino.com.ar/static/img/manifiesto/05.jpg"
              style={{ objectFit: 'cover', display: 'block' }}
            />
          </View>
        </View>
      </View>
      <View style={[styles.splitBlock, { flexDirection: isSmall ? 'column' : 'row' }]}>
        <View style={[styles.splitLeft, { width: isSmall ? '100%' : '50%', }]}>
          <View style={styles.imageBox}>
            <img
              alt="Damos todo (y recibimos todo también)"
              src="https://www.pinguino.com.ar/static/img/manifiesto/06.jpg"  
              style={{ objectFit: 'cover', display: 'block' }}
            />
          </View>
        </View>
        <View style={[styles.splitRight, { width: isSmall ? '100%' : '50%', paddingLeft: 70, paddingRight: 10,  }]}>
          <Text style={[styles.TituloManifiesto, { color: '#f15e15', marginBottom: 28 }]}>06</Text>
          <Text style={[styles.TituloManifiesto, { color: '#f15e15' }]}>Damos todo{"\n"}(y recibimos todo también)</Text>
          <Text style={[styles.listItemBold, { marginTop: 32 }]}>¿Qué nos mueve?</Text>
          <Text style={[styles.listItem, { marginBottom: 12 }]}>LAS EXPERIENCIAS SOSTENIBLES Y VALIOSAS.</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Una buena experiencia es:</Text>
          <Text style={[styles.listItem,]}>Encontrar todo lo que buscamos.</Text>
          <Text style={[styles.listItem,]}>Sorprender/se con algo nuevo, con una sonrisa, un buen trato.</Text>
          <Text style={[styles.listItem,]}>Pasar un buen momento, sentirse parte, tener confianza, querer volver. Adaptarnos, ser flexibles, buscar la evolución continua.</Text>
          <Text style={[styles.listItem,]}>Innovar, mejorar, embellecer.</Text>
          <Text style={[styles.listItem,]}>Intercambiar permanentemente.</Text>
          <Text style={[styles.listItem,]}>Simplificar el mundo de información, preseleccionando lo mejor.</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Palabras Clave</Text>
          <Text style={styles.listItem}>Tenemos mucho para dar.</Text>
          <Text style={styles.listItem}>Hacer sentir bien.</Text>
          <Text style={styles.listItem}>Dar y recibir, ¡energía en movimiento!</Text>
          <Text style={[styles.listItem, { marginTop: 18 }]}>BUENAS EXPERIENCIAS / SOLUCIONES / FLEXIBILIDAD</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>¿Cómo lo hacemos?</Text>
          <Text style={styles.listItem}>Predicamos con el ejemplo, estamos siempre, tratamos como nos gustaría que nos traten. Innovamos y nos adaptamos a nuevas realidades.</Text>
        </View>
      </View>

      <View style={[styles.splitBlock, { flexDirection: isSmall ? 'column' : 'row' }]}>
        <View style={[styles.splitRight, { width: isSmall ? '100%' : '50%', paddingLeft: 20, paddingRight: 70, }]}>
          <Text style={[styles.TituloManifiesto, { color: '#1ca655', marginBottom: 28 }]}>07</Text>
          <Text style={[styles.TituloManifiesto, { color: '#1ca655' }]}>Comercio responsable:{"\n"}nuestra forma de hacer las cosas.</Text>
          <Text style={[styles.listItemBold, { marginTop: 32 }]}>¿Qué nos mueve?</Text>
          <Text style={[styles.listItem, { marginBottom: 12 }]}>DEJAR UNA HUELLA POSITIVA EN LA COMUNIDAD, TRASCENDER. MEJORAR NUESTRO ENTORNO.</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Comercio Responsable es:</Text>
          <Text style={styles.listItem}>Fomentar el comercio local.</Text>
          <Text style={styles.listItem}>No abusar de posiciones dominantes.</Text>
          <Text style={styles.listItem}>Minimizar el impacto ambiental. Hacer las cosas bien.</Text>
          <Text style={styles.listItem}>Trabajo formal, 100%. Cumplir las leyes.</Text>
          <Text style={styles.listItem}>Comunicación transparente.</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Palabras clave</Text>
          <Text style={styles.listItem}>La forma Pingüino de hacer las cosas.</Text>
          <Text style={styles.listItem}>Impacto que genera hacer las cosas bien.</Text>
          <Text style={[styles.listItem, { marginTop: 18 }]}>TRASCENDER / RESPONSABILIDAD / COMPROMISO</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>¿Cómo lo hacemos?</Text>
          <Text style={styles.listItem}>Mostramos una forma honesta y responsable de hacer las cosas.</Text>
          <Text style={styles.listItem}>Damos el ejemplo.</Text>
        </View>
        <View style={[styles.splitLeft, { width: isSmall ? '100%' : '50%', }]}>
          <View style={styles.imageBox}>
            <img
              alt="Comercio responsable: nuestra forma de hacer las cosas"
              src="https://www.pinguino.com.ar/static/img/manifiesto/07.jpg"
              style={{ objectFit: 'cover', display: 'block' }}
            />
          </View>
        </View>
      </View>
      <View style={[styles.splitBlock, { flexDirection: isSmall ? 'column' : 'row' }]}>
        <View style={[styles.splitLeft, { width: isSmall ? '100%' : '50%', }]}>
          <View style={styles.imageBox}>
            <img
              alt="La alegría es nuestro motor"
              src="https://www.pinguino.com.ar/static/img/manifiesto/08.jpg"
              style={{ objectFit: 'cover', display: 'block' }}
            />
          </View>
        </View>
        <View style={[styles.splitRight, { width: isSmall ? '100%' : '50%',  paddingLeft: 70, paddingRight: 10, }]}>
          <Text style={[styles.TituloManifiesto, { color: '#f59aa6', marginBottom: 28 }]}>08</Text>
          <Text style={[styles.TituloManifiesto, { color: '#f59aa6' }]}>La alegría{"\n"}es nuestro motor.</Text>
          <Text style={[styles.listItemBold, { marginTop:28 }]}>¿Qué nos mueve?</Text>
          <Text style={[styles.listItem, { marginBottom: 12 }]}>VALORAR LA VIDA.</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Alegría es:</Text>
          <Text style={[styles.listItem, ]}>Generar sonrisas.</Text>
          <Text style={[styles.listItem, ]}>Que nos guste hacer lo que hacemos.</Text>
          <Text style={[styles.listItem, ]}>Solucionar problemas o ayudar a la gente a solucionar los suyos.</Text>
          <Text style={[styles.listItem, ]}>Sentir satisfacción al ver los resultados de lo que hacemos.</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Palabras Clave</Text>
          <Text style={[styles.listItem, ]}>Asesoramiento como vocación de servicio.</Text>
          <Text style={[styles.listItem, ]}>Todos tenemos algo para dar, algo que enseñar, algo que transmitir. Contagiar alegría y nutrirnos de la alegría de la gente. Aprendemos de los otros.</Text>
          <Text style={[styles.listItem, { marginTop: 18 }]}>ENERGÍA / ALEGRÍA / GENEROSIDAD</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>¿Cómo lo hacemos?</Text>
          <Text style={[styles.listItem]}>Generamos un clima de trabajo donde todos estén a gusto: si estamos en un ambiente alegre eso se transmite y contagia.</Text>
        </View> 
      </View>
      <View style={[styles.splitBlock, { flexDirection: isSmall ? 'column' : 'row' }]}>
        <View style={[styles.splitLeft, { width: isSmall ? '100%' : '50%', paddingLeft: 20, paddingRight: 70, }]}>
          <Text style={[styles.TituloManifiesto, { color: '#26ace2', marginBottom: 28 }]}>09</Text>
          <Text style={[styles.TituloManifiesto, { color: '#26ace2' }]}>Si crece uno,{"\n"}crecemos todos.</Text>
          <Text style={[styles.listItemBold, { marginTop: 6 }]}>¿Qué nos mueve?</Text>
          <Text style={[styles.listItem, { marginBottom: 12 }]}>LA SATISFACCIÓN, LA MOTIVACIÓN, EL DESARROLLO PERSONAL.</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Desarrollo personal es:</Text>
          <Text style={styles.listItem}>Entender que todo lo que aprendemos y hacemos en la empresa también queda para nosotros, en lo profesional, y en las relaciones.</Text>
          <Text style={styles.listItem}>Es nuestro capital, porque nos lo llevamos como experiencia, aprendizaje personal. Crear un buen lugar para trabajar.</Text>
          <Text style={styles.listItem}>Crecer en todos los sentidos.</Text>
          <Text style={styles.listItem}>Motivar a otros a superarse, valorar el desarrollo de nuestros clientes.</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Palabras clave</Text>
          <Text style={styles.listItem}>La fuerza del equipo nace del valor de cada una de las personas.</Text>
          <Text style={styles.listItem}>Aprender es ir siempre por más.</Text>
          <Text style={[styles.paragraph, { marginTop: 18 }]}>PROFESIONALISMO / CRECIMIENTO / FORMACIÓN CONSTANTE</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>¿Cómo lo hacemos?</Text>
          <Text style={styles.listItem}>Reconocemos lo bueno en el día a día. Con libertad para poder aportar ideas y cercanía entre todos los colaboradores.</Text>
        </View>
        <View style={[styles.splitRight, { width: isSmall ? '100%' : '50%', }]}>
          <View style={styles.imageBox}>
            <img
              alt="Si crece uno, crecemos todos"
              src="https://www.pinguino.com.ar/static/img/manifiesto/09.jpg"
              style={{ objectFit: 'cover', display: 'block' }}
            />
          </View>
        </View>
      </View>
      <View style={[styles.splitBlock, { flexDirection: isSmall ? 'column' : 'row' }]}>
        <View style={[styles.splitLeft, { width: isSmall ? '100%' : '50%', }]}>
          <View style={styles.imageBox}>
            <img
              alt="Ser nuestra mejor versión"
              src="https://www.pinguino.com.ar/static/img/manifiesto/10.jpg"
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
          </View>
        </View>
        <View style={[styles.splitRight, { width: isSmall ? '100%' : '50%', paddingLeft: 70, paddingRight: 20,  }]}>
          <Text style={[styles.TituloManifiesto, { color: '#e3ad80', marginBottom: 28 }]}>10</Text>
          <Text style={[styles.TituloManifiesto, { color: '#e3ad80' }]}>Ser nuestra{"\n"}mejor versión.</Text>
          <Text style={[styles.listItemBold, { marginTop: 28 }]}>¿Qué nos mueve?</Text>
          <Text style={[styles.listItem, { marginBottom: 12 }]}>EL AMOR Y LA PASIÓN POR NUESTRO TRABAJO.</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Amor y pasión por nuestro trabajo es:</Text>
          <Text style={styles.listItem}>Que nos guste hacer lo que hacemos. La fuerza que nos mueve a dar lo mejor, para simplificar la vida de las personas.</Text>
          <Text style={styles.listItem}>Que nuestros propósitos estén en sintonía con el de la empresa: sentirnos identificados con sus valores.</Text>
          <Text style={styles.listItem}>Salir de la zona de confort; querer ser mejores, más eficientes, empatizar con la necesidad de la gente y brindar soluciones.</Text>
          <Text style={styles.listItem}>Creer en lo que somos y en que todos tenemos algo para dar. Admirar a los que hacen las cosas con pasión.</Text>
          <Text style={styles.listItem}>Saber que la gente está a gusto en nuestro lugar.</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>Palabras Clave</Text>
          <Text style={styles.listItem}>Ser mi mejor versión como persona y formando parte de un equipo.</Text>
          <Text style={styles.listItem}>Que nos guste hacer lo que hacemos, y que nos guste hacerlo así.</Text>
          <Text style={styles.listItem}>Proponer, cambiar, hacer.</Text>
          <Text style={[styles.listItem, {marginTop: 18 }]}>EVOLUCIÓN / EQUILIBRIO / INNOVACIÓN</Text>

          <Text style={[styles.listItemBold, { marginTop: 18 }]}>¿Cómo lo hacemos?</Text>
          <Text style={styles.listItem}>Nos adaptamos constantemente, porque sabemos que la sociedad evoluciona. Nos sumamos a las últimas tendencias. Estudiamos permanentemente posibilidades, exploramos para arriesgar. Invertimos muchos recursos en innovación.</Text>
        </View>
      </View>
      <View style={{ paddingVertical: 24, alignItems: 'center' }}>
        <View style={{ width: isSmall ? '100%' : '60%', maxWidth: 720 }}>
          <img
            alt="Cierre Manifiesto"
            src="https://www.pinguino.com.ar/static/img/manifiesto/finalpag.png"
            style={{ width: '100%', height: 'auto', display: 'block', objectFit: 'cover' }}
          />
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  page: {
    backgroundColor: '#f2f2f2',
  },
  heroBlock: {
    backgroundColor: '#c92e30',
    paddingVertical: 24,
    paddingHorizontal: 16,
  },
  hero: {
    maxWidth: 1120,
    width: '64%',
    alignSelf: 'center',
    gap: 16,
    paddingHorizontal: 16,
    marginTop: 20,
  },
  splitBlock: {
    maxWidth: 1120,
    width: '100%',
    alignSelf: 'center',
    gap: 16,
    paddingVertical: 24,
    paddingHorizontal: 0,
  },

  imageBox: {
    width: '100%',
    height: '100%',
    backgroundColor: '#f2f2f2',
  },
  splitRight: {
    justifyContent: 'center',
  },
  TituloManifiesto: {
    fontWeight: 'bold',
    fontSize: 32,
    color: colores.textoPrincipal,
  },
  splitTitle: {
    fontFamily: fuentes.semiBold,
    fontSize: 22,
    color: colores.textoPrincipal,
  },
  
  splitSubtitle: {
    fontFamily: fuentes.regular,
    fontSize: 28,
    color: colores.textoPrincipal,
    marginTop: 2,
  },
  splitBig: {
    fontFamily: fuentes.semiBold,
    fontSize: 26,
    color: colores.textoPrincipal,
    marginVertical: 6,
  },
  listBlock: {
    marginTop: 12,
    gap: 6,
  },
  listItem: {
    fontFamily: fuentes.regular,
    fontSize: 15,
    color: colores.textoPrincipal,
    lineHeight: 22,
  },
  listItemBold: {
    fontFamily: fuentes.bold,
    fontSize: 15,
    color: colores.textoPrincipal,
    lineHeight: 22,
  },

  heroLeft: {
    paddingRight: 20,
  },
  heroRight: {
    justifyContent: 'center',
    paddingLeft: 20,
  },
  heroHeading: {
    color: colores.blanco,
    fontFamily: fuentes.semiBold,
  },
  heroParagraph: {
    color: colores.blanco,
    fontFamily: fuentes.regular,
    marginBottom: 8,
  },
  container: {
    maxWidth: 960,
    width: '100%',
    alignSelf: 'center',
  },
  title: {
    fontFamily: fuentes.semiBold,
    fontSize: 28,
    color: colores.textoPrincipal,
    marginBottom: 16,
    textAlign: 'left',
  },
  paragraph: {
    fontFamily: fuentes.regular,
    fontSize: 16,
    lineHeight: 22,
    color: colores.textoPrincipal,
    marginBottom: 12,
    textAlign: 'left',
  },
  numLabel: {
    fontFamily: fuentes.semiBold,
    fontSize: 14,
    color: colores.textoPrincipal,
    marginBottom: 6,
  },
});

export default Manifiesto;
